// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I0FG","label":"styles_label__2vSPv"};